import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("azd_user") || "null");
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("azd_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("azd_user", JSON.stringify(data));
    } catch {
      setUser(null);
      localStorage.removeItem("azd_token");
      localStorage.removeItem("azd_user");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("azd_token", data.token);
    localStorage.setItem("azd_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("azd_token");
    localStorage.removeItem("azd_user");
    setUser(null);
    window.location.href = "/login";
  };

  const token = () => localStorage.getItem("azd_token");

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh, token }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const ROLES = {
  admin: "Süper Admin",
  sales: "Satış Personeli",
  accounting: "Muhasebe",
  warehouse: "Depo / Stok",
  procurement: "Satın Alma",
  viewer: "Sadece Görüntüleme",
};

export const hasRole = (user, ...roles) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  return roles.includes(user.role);
};
